import React from "react";

export default function About(){
    return (
        <section id="about" className="about">
            <div className="container">
                <h2>About Me</h2>
                <p>
                    I am an undergraduate student at the University of Vavuniya, working toward 
          a Bachelor's degree in Information & Communication Technology (Hons).
                
                     I have a strong interest in technology and like to create practical solutions 
          for real-world problems. I am eager to learn new tools and ideas, and I keep 
          building my skills by working on hands-on projects.
               
                    I am motivated and adaptable, and I value creativity, teamwork, and learning 
          new things. I like to take on challenges and turn ideas into real results.
                </p>
            </div>
        </section>
    );

}
